export default __webpack_public_path__ + "static/media/Log_In_bg_image.decbd6ab.png";